import { CreditCard, IOrderBumpState } from "./model";
import { createReducer, on } from "@ngrx/store";
import { actions } from ".";

import { selectEdition as checkoutSelectEdition } from "../../store/actions";
import { assign } from "lodash";
import { CreditCardPaymentMethod } from "../../store";

export const ORDER_BUMP_FEATURE_KEY = "order-bump";

export const initialOrderBumpState: IOrderBumpState = {
    loading: false,
    loadingCustomerInfo: false,
    paymentMethod: CreditCardPaymentMethod,
    creditCard: undefined,
    discount: undefined,
    discountVoucher: undefined,
    availableProducts: [],
    selectedProducts: [],
    selectedProductIds: [],
    price: 0,
    total: 0,
    installmentTotal: 0,
    maxNumberOfInstallments: 1,
};

export const orderBumpReducer = createReducer(
    initialOrderBumpState,
    on(checkoutSelectEdition, (state, { edition, locked }) => {
        if (!edition.orderBump || edition.orderBump.items.length === 0) {
            return { ...state };
        }
        let orderBump = edition.orderBump;

        let total = orderBump.price;

        if (orderBump.discount) {
            total -= orderBump.discount;
        }

        return {
            ...state,
            paymentMethod: orderBump.paymentMethod,
            discount: orderBump.discount,
            discountVoucher: orderBump.discountVoucher,
            price: orderBump.price,
            total: total,
            selectedProductIds: orderBump.items,
            maxNumberOfInstallments: orderBump.maxNumberOfInstallments,
        };
    }),
    on(actions.setCreditCard, (state, { creditCard }) => {
        if (!creditCard) {
            return {
                ...state,
            };
        }
        return {
            ...state,
            creditCard: assign(new CreditCard(), creditCard, { digits: state.creditCard.digits }),
        };
    }),
    on(actions.loadCustomerPaymentInfoAction.execute, (state) => ({
        ...state,
        loadingCustomerInfo: true,
    })),
    on(actions.loadCustomerPaymentInfoAction.complete, (state, { info }) => ({
        ...state,
        loadingCustomerInfo: false,
        creditCard: info,
    })),
    on(actions.loadCustomerPaymentInfoAction.failure, (state, { error }) => ({
        ...state,
        loadingCustomerInfo: false,
        error: error,
    })),
    on(actions.createOrderAction.execute, (state) => ({
        ...state,
        loading: true,
    })),
    on(actions.createOrderAction.complete, (state) => ({
        ...state,
        loading: false,
    })),
    on(actions.createOrderAction.failure, (state) => ({
        ...state,
        loading: false,
    })),
    on(actions.loadAvailableAdditionalProductsComplete, (state, { products }) => {
        let selectedProducts = [];
        for (let id of state.selectedProductIds) {
            let product = products.find((p) => p.id === id);
            if (product) {
                selectedProducts.push(product);
            }
        }

        let installmentTotal = selectedProducts.reduce((acc, curr) => {
            acc += curr.installmentPrice;
            return acc;
        }, 0);

        if (state.discount) {
            installmentTotal -= state.discount;
        }

        return {
            ...state,
            loading: false,
            availableProducts: products,
            selectedProducts: selectedProducts,
            installmentTotal: installmentTotal,
        };
    }),
    on(actions.loadAvailableAdditionalProductsError, (state, { error }) => ({
        ...state,
        loading: false,
    }))
);
